

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Dashboard React base styles
import colors from "assets/theme/base/colors";

function Ruler({ color, size }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink" viewBox="0 -6 20 20" version="1.1">

      <title>ruler#2_round [#867]</title>
      <desc>Created with Sketch.</desc>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Dribbble-Light-Preview" transform="translate(-180.000000, -4365.000000)" fill="#000000">
          <g id="icons" transform="translate(56.000000, 160.000000)">
            <path d="M127,4209 C127,4208.448 127.448,4208 128,4208 C128.552,4208 129,4208.448 129,4209 C129,4209.552 128.552,4210 128,4210 C127.448,4210 127,4209.552 127,4209 L127,4209 Z M142,4210 C142,4210.552 141.552,4211 141,4211 L140,4211 L140,4210 C140,4209.448 139.552,4209 139,4209 C138.448,4209 138,4209.448 138,4210 L138,4211 L136,4211 L136,4210 C136,4209.448 135.552,4209 135,4209 C134.448,4209 134,4209.448 134,4210 L134,4211 L132,4211 L132,4210 C132,4209.448 131.552,4209 131,4209 C130.448,4209 130,4209.448 130,4210 L130,4211 L127,4211 C126.448,4211 126,4210.552 126,4210 L126,4208 C126,4207.448 126.448,4207 127,4207 L141,4207 C141.552,4207 142,4207.448 142,4208 L142,4210 Z M142,4205 L126,4205 C124.895,4205 124,4205.895 124,4207 L124,4211 C124,4212.105 124.895,4213 126,4213 L130,4213 L132,4213 L134,4213 L136,4213 L138,4213 L140,4213 L142,4213 C143.105,4213 144,4212.105 144,4211 L144,4207 C144,4205.895 143.105,4205 142,4205 L142,4205 Z" id="ruler#2_round-[#867]">

            </path>
          </g>
        </g>
      </g>
    </svg>
  );
}

// Setting default values for the props of Office
Ruler.defaultProps = {
  color: "dark",
  size: "16px",
};

// Typechecking props for the Office
Ruler.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
    "white",
  ]),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Ruler;
